export const pageurl = {
	LOGIN: '/',
	OVERVIEW: '/dashboard/overview',
	VERIFYOTP: '/verify-otp',
	REQUESTACCESS: '/request-access',
	RESULTANALYTICS: '/dashboard/result-analytics',
	ONBOARDING: '/onboarding',
	// Observer invite links land here; same Onboarding page, `applicantRole='observer'`.
	OBSERVER_ONBOARDING: '/observer-onboarding',
	SETTINGS: '/dashboard/settings',
	SETTINGSPROFILE: '/dashboard/settings/profile',
	SETTINGSBANKDETAILS: '/dashboard/settings/bank-details',
	SETTINGSGOVERNMENTID: '/dashboard/settings/government-id',
};
